import * as React from "react";

function NewMatherMetalsIcon(props) {
  const { className, height, width } = props;

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={width}
      height={height}
      viewBox="0 0 53 44"
    >
      <defs>
        <clipPath>
          <rect width="53" height="44" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip-new-mather-metals)">
        <path
          data-name="Path 7147"
          d="M1.336,0V-12.885H3.867l5.273,8.6v-8.6h2.417V0H8.947L3.753-8.4V0ZM14.273,0V-12.885h3.894L20.5-4.1l2.312-8.789h3.9V0H24.3V-10.143L21.744,0h-2.5L16.69-10.143V0ZM29.268,0V-12.885h3.894L35.5-4.1l2.312-8.789h3.9V0H39.3V-10.143L36.738,0h-2.5L31.685-10.143V0Zm14.95,0V-12.885h2.6V0Z"
          transform="translate(2 39)"
        />
        <path
          data-name="Path 7146"
          d="M1.633,0V-15.748H4.727L11.172-5.231V-15.748h2.954V0h-3.19L4.587-10.27V0ZM17.5,0V-15.748h3.18v6.2h6.23v-6.2h3.18V0h-3.18V-6.886h-6.23V0Zm15.92,0V-15.748H36.6v6.993l6.424-6.993H47.3l-5.93,6.134L47.62,0H43.506L39.177-7.391,36.6-4.759V0Z"
          transform="translate(2 20)"
          fill="#d51010"
        />
      </g>
    </svg>
  );
}

export default NewMatherMetalsIcon;
